import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shigo-ui/ui';

import {
  madBuyLineItemPacingLabels,
  madBuyLineItemPacingOptions,
  type MadBuyLineItemPacing,
} from '../../lineItemsModel';

export function LineItemPacingSelect({
  ariaLabel,
  onValueChange,
  value,
}: {
  ariaLabel: string;
  onValueChange: (value: MadBuyLineItemPacing) => void;
  value: MadBuyLineItemPacing;
}) {
  return (
    <Select
      value={value}
      onValueChange={(nextValue) => {
        onValueChange(nextValue as MadBuyLineItemPacing);
      }}
    >
      <SelectTrigger aria-label={ariaLabel}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {madBuyLineItemPacingOptions.map((option) => (
          <SelectItem key={option} value={option}>
            {madBuyLineItemPacingLabels[option]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
